import { Node } from 'tiptap';

export default class Elements extends Node {
  // eslint-disable-next-line class-methods-use-this
  get name() {
    return 'elements';
  }

  // eslint-disable-next-line class-methods-use-this
  get schema() {
    return {
      inline: true,
      attrs: {
        type: {
          default: null,
        },
        class: {
          default: null,
        },
      },
      selectable: false,
      group: 'inline',
      content: 'text*',
      parseDOM: [
        {
          getAttrs: dom => ({
            type: dom.getAttribute('type'),
            class: dom.getAttribute('class'),
          }),
        },
      ],
      toDOM: node => [
        'span',
        {
          class: node.attrs.type,
        },
        [
          'span',
          {
            type: node.attrs.type,
          },
          0,
        ],
      ],
    };
  }

  // eslint-disable-next-line class-methods-use-this
  commands({ type }) {
    return attrs => (state, dispatch) => {
      const { selection } = state;
      const position = selection.$cursor ? selection.$cursor.pos : selection.$to.pos;
      const node = type.create(attrs);
      const transaction = state.tr.insert(position, node);
      dispatch(transaction);
    };
  }

  // eslint-disable-next-line class-methods-use-this
  get view() {
    return {
      props: ['node', 'updateAttrs', 'view', 'options'],
      computed: {
        src: {
          get() {
            return this.node.attrs.src;
          },
          set(src) {
            this.updateAttrs({
              src,
            });
          },
        },
      },
      template: `
        <span v-if="node.attrs.type === 'checkbox'" class="flex mb-1">
          <input type="text" v-if="view.editable" />
          <input type="checkbox" v-if="view.editable" />
        </span>
        <span v-else-if="node.attrs.type === 'radio'" class="flex mb-1">
          <input type="text" v-if="view.editable" />
          <input type="radio" v-if="view.editable" />
        </span>
        <span v-else-if="node.attrs.type === 'signature'" class="flex flex-column mb-1">
          <span class="signature">Sign here</span>
        </span>
      `,
    };
  }
}



// WEBPACK FOOTER //
// ./src/includes/elements.js